import { useEffect, useState } from 'react';
import { Link } from 'react-router';

import { usePageTitle } from '@/hooks/use-page-title';
import { useMe } from '@/platform/auth/use-me';
import { AdminSectionList } from '@/platform/components/admin-section-list';
import { PlatformPageHeader } from '@/platform/components/platform-page-header';
import { useUsers } from '@/platform/features/users/use-users';
import {
  canOpenAdmin,
  DIRECTORY_ADMIN_PATH,
  platformAdminLinkGroups,
  MODULES_ADMIN_PATH,
  USERS_ADMIN_PATH,
} from '@/platform/lib/admin';

const EMPTY_TIPS_DISMISSED_KEY = 'gb-ticket.admin-empty-tips-dismissed';

export function AdminHomePage() {
  usePageTitle('Verwaltung');
  const me = useMe();
  const groups = me.data ? platformAdminLinkGroups(me.data) : [];
  const canAdmin = me.data ? canOpenAdmin(me.data) : false;
  const users = useUsers({
    page: 1,
    pageSize: 1,
    sortBy: 'lastName',
    sortOrder: 'asc',
    status: 'all',
  });
  const [tipsDismissed, setTipsDismissed] = useState(() =>
    typeof localStorage === 'undefined'
      ? false
      : localStorage.getItem(EMPTY_TIPS_DISMISSED_KEY) === '1',
  );

  useEffect(() => {
    if (tipsDismissed) {
      localStorage.setItem(EMPTY_TIPS_DISMISSED_KEY, '1');
    }
  }, [tipsDismissed]);

  const showEmptyTips = canAdmin && !tipsDismissed && users.data?.total === 1 && users.isSuccess;

  return (
    <section className="space-y-6">
      <PlatformPageHeader
        title="Verwaltung"
        description="Zentrale Einstellungen des Mitarbeiterportals."
      />
      {showEmptyTips ? (
        <div className="rounded-lg border border-border bg-muted/40 px-4 py-3 text-sm">
          <p className="font-medium">Erste Schritte</p>
          <ul className="mt-2 list-inside list-disc space-y-1 text-muted-foreground">
            <li>
              <Link
                className="text-primary underline-offset-4 hover:underline"
                to={DIRECTORY_ADMIN_PATH}
              >
                Verzeichnis verbinden
              </Link>
            </li>
            <li>
              <Link
                className="text-primary underline-offset-4 hover:underline"
                to={MODULES_ADMIN_PATH}
              >
                Module verwalten
              </Link>
            </li>
            <li>
              <Link
                className="text-primary underline-offset-4 hover:underline"
                to={USERS_ADMIN_PATH}
              >
                Benutzer anlegen
              </Link>
            </li>
          </ul>
          <button
            type="button"
            className="mt-3 text-xs text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
            onClick={() => setTipsDismissed(true)}
          >
            Hinweise ausblenden
          </button>
        </div>
      ) : null}
      <AdminSectionList groups={groups} />
    </section>
  );
}
